import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import CSS from 'csstype';
import React, { useContext } from 'react';
import getLanguageObject from 'utils/getLanguageObject';

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24
        }}
        spin={true}
    />
);

type LoadingWrapperProps = {
    children: React.ReactNode;
    loading: boolean;
    download?: boolean;
    error?: string;
    style?: CSS.Properties;
};

/* Wrapper vykreslující spinner s hláškou "načítám", použitý při volání REST požadavků */
const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
    children,
    loading,
    error,
    style,
    download
}: LoadingWrapperProps) => {
    const { language } = useContext(Context);

    if (error)
        return (
            <p>
                <TranslateText>CHYBA_NACITANI</TranslateText>: {error}
            </p>
        );
    if (loading)
        // if (download)
        //     return (
        //         <Spin indicator={antIcon} tip={getLanguageObject(language).STAHOVANI} size="large" style={style}>
        //             {children}
        //         </Spin>
        //     );
        // else
        return (
            <Spin
                indicator={antIcon}
                tip={download ? getLanguageObject(language).STAHOVANI : getLanguageObject(language).NACITANI}
                size="large"
                style={style}
            >
                {children}
            </Spin>
        );

    return <>{children}</>;
};

export default LoadingWrapper;
